export function handleFormErrors(formErrors, data, formRef) {
  if (formErrors != undefined) {
    for (let formError of formErrors) {
      const property = formError.propertyPath + "Rules";
      if (data[property] != undefined) {
        data[property].push((v) => v != v || formError.title);
      }
    }
    if (formRef != null) {
      formRef.validate();
    }

    // BAD trick to removeError for the next validation
    for (let formError of formErrors) {
      const property = formError.propertyPath + "Rules";
      if (data[property] != undefined) {
        data[property].pop();
      }
    }
  }
}
